import React, { useState } from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
import LOGO from '../images/logo.png';
import { Link } from 'react-router-dom';

const Footer = () => {
  const [subscribeEmail, setSubscribeEmail] = useState('');
  const [subscribeStatus, setSubscribeStatus] = useState('');

  const handleSubscribe = async (e) => {
    e.preventDefault();
    setSubscribeStatus('');
    try {
      const res = await fetch('https://python.rock-safaris.com/contact/subscribe/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: subscribeEmail }),
      });
      const data = await res.json();
      setSubscribeStatus(data.message);
      if (res.ok) setSubscribeEmail('');
    } catch {
      setSubscribeStatus('Error subscribing. Please try again.');
    }
  };

  return (
    <footer className="bg-kenya-brown text-white pt-5 pb-3">
      <div className="container">
        <div className="row g-4">
          {/* Brand & Description */}
          <div className="col-md-4">
            <img
              src={LOGO}
              alt="Hunters Rock Tours Logo"
              className="d-inline-block align-middle d-none d-md-block footer-logo mb-3"
              style={{
                width: 120,
                height: 140,
                objectFit: 'contain',
                marginRight: 8,
            
             
               
              }}
            />
            <h5 className="d-md-none fw-bold mb-3">Hunters Rock Tours</h5>
            <p>
              Experience the magic of Kenya with our reliable and breathtaking tours and safaris.
            </p>
          </div>
          {/* Quick Links */}
          <div className="col-md-2">
            <h5 className="fw-semibold mb-3">Quick Links</h5>
            <ul className="list-unstyled">
              <li>
                <Link to="/" className="text-white text-decoration-none">Home</Link>
              </li>
              <li>
                <Link to="/about" className="text-white text-decoration-none">About</Link>
              </li>
              <li>
                <Link to="/services" className="text-white text-decoration-none">Services</Link>
              </li>
              <li>
                <Link to="/gallery" className="text-white text-decoration-none">Gallery</Link>
              </li>
              <li>
                <Link to="/contact" className="text-white text-decoration-none">Contact</Link>
              </li>
            </ul>
          </div>
          {/* Contact Info */}
          <div className="col-md-3">
            <h5 className="fw-semibold mb-3">Contact</h5>
            <ul className="list-unstyled">
              <li className="mb-2 d-flex align-items-center">
                <Phone size={18} className="me-2 text-kenya-orange" />
                <a href="tel:+254705665977" className="text-white text-decoration-none">
                 +254792400119
                </a>
              </li>
              <li className="mb-2 d-flex align-items-center">
                <Mail size={18} className="me-2 text-kenya-orange" />
                <a href="mailto:info@rock-safaris.com" className="text-white text-decoration-none">
                  info@rock-safaris.com
                </a>
              </li>
              <li className="mb-2 d-flex align-items-center">
                <MapPin size={18} className="me-2 text-kenya-orange" />
                <span>Nairobi, Kenya</span>
              </li>
            </ul>
          </div>
          {/* Subscribe */}
          <div className="col-md-3">
            <h5 className="fw-semibold mb-3">Subscribe</h5>
            <form onSubmit={handleSubscribe}>
              <div className="input-group mb-2">
                <input
                  type="email"
                  className="form-control"
                  placeholder="Your email"
                  aria-label="Your email"
                  required
                  value={subscribeEmail}
                  onChange={e => setSubscribeEmail(e.target.value)}
                />
                <button className="btn btn-kenya-orange text-white" type="submit">
                  Subscribe
                </button>
              </div>
              <small className="text-kenya-yellow">Get updates & offers from us!</small>
              {subscribeStatus && (
                <div className="mt-2 small text-white">{subscribeStatus}</div>
              )}
            </form>
          </div>
        </div>
        <hr className="border-kenya-orange my-4" />
        <div className="text-center text-kenya-yellow small">
          &copy; {new Date().getFullYear()} <a href="rock-safaris.com" className="text-kenya-yellow text-decoration-none">rock-safaris</a> &mdash; Hunters Rock Tours & Safaris. All rights reserved.
        </div>
      </div>
    </footer>
  );

}
export default Footer;